import { render, staticRenderFns } from "./block-text-big.vue?vue&type=template&id=59a79d40"
import script from "./block-text-big.vue?vue&type=script&lang=js"
export * from "./block-text-big.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports